import { Title, Text, Container, Grid, Image, Button } from '@mantine/core';

const SectionSeven = () => {
    //const theme = useMantineTheme();

    return (
        <section id="section-seven">
            <Container>
                <Grid justify="space-around">
                     <Grid.Col xs={6} sm={4} md={4} lg={4}>    
                    </Grid.Col>
                </Grid>
            </Container>
        </section>
    )
};

export default SectionSeven;
